import { Download, FileText, ShieldCheck, CreditCard, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

type Props = { className?: string; compact?: boolean };

const items = [
  {
    icon: Download,
    label: "Free download, no login",
    href: "/templates",
    title: "Download resume templates free with no login",
  },
  {
    icon: FileText,
    label: "Word & PDF export",
    href: "/templates",
    title: "Export your resume as Word and PDF",
  },
  {
    icon: CreditCard,
    label: "Free — no credit card",
    href: "/features",
    title: "Every feature is free forever",
  },
  {
    icon: ShieldCheck,
    label: "ATS-Optimized templates",
    href: "/ats-resume-builder",
    title: "ATS-friendly resume builder",
  },
  {
    icon: Sparkles,
    label: "Watermark-free PDF",
    href: "/features",
    title: "Free PDF export, no watermark",
  },
];

export function SocialProofBar({ className = "", compact = false }: Props) {
  return (
    <ul
      className={`flex flex-wrap items-center justify-center gap-2 ${compact ? "text-xs" : "text-sm"} ${className}`}
      aria-label="Trust and social proof"
    >
      {items.map((i) => (
        <li key={i.label}>
          <Link
            to={i.href}
            title={i.title}
            className={`group inline-flex items-center gap-2 rounded-md border border-border bg-card text-muted-foreground shadow-xs transition-colors duration-180 ease-premium hover:border-border-strong hover:bg-surface-raised hover:text-foreground focus-visible:border-border-strong focus-visible:text-foreground ${
              compact ? "px-2.5 py-1.5" : "px-3.5 py-2"
            }`}
          >
            <i.icon
              className={`${compact ? "w-3.5 h-3.5" : "w-4 h-4"} shrink-0 text-primary`}
              aria-hidden="true"
            />
            <span className="whitespace-nowrap">{i.label}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}
